import { put, takeEvery, all, call, select } from 'redux-saga/effects';
import {
  createBusinessLineSuccess,
  createBusinessLineError,
  deleteBusinessLineSuccess,
  deleteBusinessLineError,
} from '../actions/businessLines';
import {
  CREATE_BUSINESS_LINE,
  DELETE_BUSINESS_LINE,
} from '../constants/action-types/businessLines';
import { makeSelectIdTkn } from '../selectors/auth';
import clientApi from '../utils/clientApi';

// Utils
function* createHeader(opts = {}) {
  const idToken = yield select(makeSelectIdTkn());
  const options = JSON.parse(JSON.stringify(opts));
  options.headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${idToken}`,
  };
  return options;
}

function* createBusinessLine(action) {
  try {
    const options = yield call(createHeader);
    const res = yield call(clientApi.post, '/business-lines', action.payload, options);
    yield put(createBusinessLineSuccess(res.data));
  } catch (e) {
    yield put(createBusinessLineError(e));
  }
}

function* deleteBusinessLine(action) {
  try {
    const options = yield call(createHeader);
    yield call(clientApi.delete, `/business-lines/${action.payload.id}`, options);
    yield put(deleteBusinessLineSuccess());
  } catch (e) {
    yield put(deleteBusinessLineError(e));
  }
}

function* watchCreateBusinessLine() {
  yield takeEvery(CREATE_BUSINESS_LINE, createBusinessLine);
}

function* watchDeleteBusinessLine() {
  yield takeEvery(DELETE_BUSINESS_LINE, deleteBusinessLine);
}

export default function* businessLinesSaga() {
  yield all([watchCreateBusinessLine(), watchDeleteBusinessLine()]);
}
